import React from 'react';
import { useDispatch } from 'react-redux';
import { SolutionCenterContentTypes, ZendeskSearchArticle } from '../../../types/solution-center';
import { setSolutionCenterContentState } from '../../../stores/actions/user-interface';
import PaginationControls from '../pagnation-controls';
import ComingSoon from '../../general-components/coming-soon';
import TellySad from '../../../images/telly-sad.svg';
import LoadingSpinner, { LoadingSpinnerType } from '../../general-components/loading-spinner';

interface SearchViewProps {
	isSearching: boolean;
	searchString: string;
	currentPage: number;
	totalPages: number;
	searchResults: ZendeskSearchArticle[];
	handleSearch: (searchString: string) => void;
	handleSelectCategory: (categoryId: number) => void;
	handleSelectSection: (sectionId: number) => void;
}

export default function SearchView(props: SearchViewProps) {
	const dispatch = useDispatch();

	const {
		isSearching,
		searchString,
		currentPage,
		totalPages,
		searchResults,
		handleSearch,
		handleSelectCategory,
		handleSelectSection,
	} = props;

	return (
		<>
			{isSearching ? (
				<div className="sc-loading">
					<LoadingSpinner
						height={36}
						width={36}
						type={LoadingSpinnerType.Gradient}
						style={{ background: '#26242B' }}
					/>
				</div>
			) : (
				<ul className="sc-list">
					{searchResults.length > 0 ? (
						searchResults.map((s) => (
							<li key={`search-article-${s.id}`} className="sc-search-item">
								<h6
									className="sc-search-item-title truncate"
									onClick={() => dispatch(setSolutionCenterContentState({
										id: s.id,
										type: SolutionCenterContentTypes.Article,
									}))}
								>
									{s.title}
								</h6>
								<div className="sc-search-item-breadcrumbs">
									<h6 className="sc-search-item-title" onClick={() => handleSelectCategory(s.category_id)}>
										{s.category_name}
									</h6>
									<h6 className="sc-search-item-title" style={{ cursor: 'default' }}>
										&nbsp;&gt;&nbsp;
									</h6>
									<h6 className="sc-search-item-title truncate" onClick={() => handleSelectSection(s.section_id)}>
										{s.section_name}
									</h6>
								</div>
								<p className="sc-search-item-snippet" dangerouslySetInnerHTML={{ __html: s.snippet }} />
								<span className="sc-c2-text date">
									Updated&nbsp;
									{new Date(s.updated_at).toLocaleDateString('en-US', {
										year: 'numeric',
										month: 'long',
										day: 'numeric',
										hour: '2-digit',
										minute: 'numeric',
									})}
								</span>
							</li>
						))
					) : (
						<ComingSoon
							title="Nothing to see here... yet."
							body="We couldn't find anything that matches your search.&#10;Try that again using different keywords."
							className="no-results"
							tellyImage={TellySad}
						/>
					)}
				</ul>
			)}
			<PaginationControls
				isLoading={isSearching}
				currentPage={currentPage}
				totalPages={totalPages}
				onPageChange={(newPage: number) => {
					handleSearch(`${searchString}&page=${newPage}`);
				}}
			/>
		</>
	);
}
